var React = require('react');

function Seven (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","fill":"#1DB4FF","d":"M37.35 30.65c2.94-3.23 8.63-8.38 11.56-11.04a1.1 1.1 0 00-.62-1.91c-4.53-.49-13.93-1.5-15.56-1.28-.24-.24-.35-.5-.45-.71a7929.9 7929.9 0 00-6.36-14.35 1.09 1.09 0 00-1.99 0c-1.53 3.43-4.45 10.01-6.1 13.79-.27.62-.57 1.45-1.28.97-2.06.18-10.44 1.09-15 1.57a1.1 1.1 0 00-.62 1.91l11.64 10.54c.14.13.23.25.18.47-.8 3.8-2.43 12.29-3.26 15.83-.2.54.8 1.26 1.61.79l13.53-7.85c.23-.13.51-.12.6 0l13.5 7.84c.82.47 1.81-.25 1.62-.82-.78-4.12-1.97-11.4-3.2-15.61.67-.3-.05-.5.2-.14z"}));
}

Seven.defaultProps = {"viewBox":"0 0 50 48","height":"100%","width":"100%"};

module.exports = Seven;

Seven.default = Seven;
